import * as React from 'react';
import {
  toast as toastV2,
  type ToastVariant as ToastVariantV2,
} from '@e2n/ui/v2';

type ToastVariant = 'success' | 'info' | 'warning' | 'destructive';

interface ToastProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: ToastVariant;
}

// Alte Varianten-Namen auf die des V2-Toasts abbilden; ohne Variante → success.
const variantMap: Record<ToastVariant, ToastVariantV2> = {
  success: 'success',
  info: 'information',
  warning: 'warning',
  destructive: 'error',
};

function toast({ title, description, variant = 'success' }: ToastProps) {
  return toastV2({ variant: variantMap[variant], title, description });
}

function useToast() {
  return { toast };
}

export { useToast, toast };
